/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'tasks-icon': {
    width: 24,
    height: 33,
    viewBox: '0 0 24 33',
    data: '<path pid="0" _fill="none" _stroke="#059CEB" d="M18.431 5.553H21.3c1.05 0 1.9.85 1.9 1.9v22.745a1.9 1.9 0 0 1-1.9 1.9H2.72a1.9 1.9 0 0 1-1.9-1.9V7.453a1.9 1.9 0 0 1 1.9-1.9h2.869v-.398c0-.751.609-1.36 1.36-1.36h1.808a3.355 3.355 0 0 1 6.507 0h1.808c.751 0 1.36.609 1.36 1.36v.398zm-3.21-.13a1.579 1.579 0 0 1-1.534-1.218 1.726 1.726 0 0 0-3.355 0 1.58 1.58 0 0 1-1.533 1.218H7.216v1.718h9.587V5.423H15.22zm-6.694 9.933a1.778 1.778 0 1 0-3.555 0 1.778 1.778 0 0 0 3.555 0zm3.188.815h8.146v-1.629h-8.146v1.629zm-3.188 7.138a1.778 1.778 0 1 0-3.555 0 1.778 1.778 0 0 0 3.555 0zm3.188.814h8.146v-1.628h-8.146v1.628z"/>'
  }
})



// WEBPACK FOOTER //
// ./src/compiled-icons/tasks-icon.js